import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AdjustmentModel } from 'src/app/models/adjustment.model';
import { AdjustmentService } from 'src/app/services/adjustment.service';
import { DatacheckService } from '../../services/datacheck.service';
import { severitymessage, FunctionalityNames, LanguageConstants, AdjustmentMessageConstants } from '../../shared-components/constant';
import { EngagementService } from '../../services/engagement.service';
import { FlatfileService } from '../../services/flatfile.service';
import { saveAs } from 'file-saver';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { AuditingService } from 'src/app/services/auditing.service';
import { UserService } from 'src/app/services/user.service';
import { UserModel } from 'src/app/models/user.model';
import { WebJobQueueService } from 'src/app/services/webjobqueue.service';
import { WebJobQueueModel } from 'src/app/models/webJobQueue.model';
import { InfraService } from 'src/app/services/infra.service';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions } from 'ngx-uploader';
import { Sharedservice } from './../../shared-components/shared.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { EngagementModel } from 'src/app/models/engagement.model';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { MasterHelpService } from 'src/app/services/masterhelp.service';
import { TemplateEnum } from 'src/app/enums/regions.enum';

@Component({
  standalone: false,
  selector: 'app-selectadjustment',
  templateUrl: './selectadjustment.component.html',
  styleUrls: ['./selectadjustment.component.css']
})
export class SelectadjustmentComponent implements OnInit {
  engagementId = +this.route.snapshot.paramMap.get('id');
  adjustments: AdjustmentModel[];
  cols: any[];
  colsQE: any[];
  confirmdisplay = false;
  accountDetailsQE: any[] = [];
  frozenCols: any[];
  loadspinner = false;
  public results: any[] = [];
  public pagerows: number;
  loadspinnerflatfile = false;
  flatfileName = '';
  isTimeIntervalInProgressFlatFileDownload = false;
  timeOutHandlerFlatFileDownload: NodeJS.Timer;
  flatFileDownloadWebJobQueueId: number;
  private loggedInUserId: number;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }
  engagementName: string = null;
  sourceFiles: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  options: UploaderOptions;
  humanizeBytes: Function;
  private maxFlatFileSizeUploadLimit = environment.maxFlatFileSizeUploadLimit * 1024 * 1024;
  adjustmentUploadURL = '';
  adjustableCSSClass = 'col-md-6 col-xs-12 col-lg-6 col-sm-12 PadLNull  marg-bot15 marg-top10 engagementsection selectadjusttable';
  engagementTemplateId = 1;
  public selectedregion = null;
  flatfileUploaded: number;
  currLangTranslation: any;
  langCode: string;
  EXCEL_CONTENT_TYPE: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  constructor(private infraService: InfraService, private adjustmentService: AdjustmentService, private messageService: MessageService,
    private router: Router, private route: ActivatedRoute, private datacheckService: DatacheckService,
    public confirmationService: ConfirmationService, private flatFileService: FlatfileService, private userService: UserService,
    private engagementservice: EngagementService, private auditingService: AuditingService,
    private webJobQueueService: WebJobQueueService, public sharedService: Sharedservice,
    private translateService: TranslateService, private httpClient: HttpClient, private masterHelpService: MasterHelpService) {

    this.infraService.infraDetails$.subscribe(data => {
      const regionId = data.InfraId; this.selectedregion = data.InfraId;
      this.adjustmentUploadURL = data.WebEndPoint2 + 'adjustment/UploadAdjustmentTemplate/';
      this.flatfileUploaded = this.sharedService.getLocalStorageValueByName('isTempFlatfileUploaded' + this.engagementId +
        this.selectedregion);

      const templateId = + localStorage.getItem('currentEngagementTemplateId' + regionId + this.engagementId)
      this.engagementName = localStorage.getItem('currentEngagement' + this.engagementId + regionId);

      if (templateId == 3) {
        this.adjustableCSSClass = 'col-md-12 col-xs-12 col-lg-12 col-sm-12 PadLNull marg - bot15 marg - top10 engagementsection selectadjusttable';
      }

      this.engagementTemplateId = templateId;
      this.cols = [
        { field: 'Id', header: 'Id', visible: false, isEditable: false },
        { field: 'Select', header: 'Select', visible: true, isEditable: false },
        { field: 'adjustmentName', header: 'Title', visible: true, isEditable: false },
        { field: 'adjustmentCategory', header: 'Category', visible: (this.engagementTemplateId == 3) ? true : false, isEditable: false },
        { field: 'adjustmentType', header: 'Type', visible: true, isEditable: false },
        { field: 'modifiedById', header: 'Created By', visible: true, isEditable: false },
        { field: 'modifiedDate', header: 'Created Date', visible: true, isEditable: false },
        { field: 'Action', header: 'Action', visible: true, isEditable: false }
      ];
    });

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
      }
    });

    this.options = {
      concurrency: 1,
      allowedContentTypes: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel.sheet.macroEnabled.12']
    };
    this.sourceFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.loadspinner = true;
    this.messageService.clear('myKey1');
    this.pagerows = environment.pageRows;
    this.getMyAdjustments();
    this.fetchdatacheck_LeadQE();

    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.fetchdatacheck_LeadQE();
    });
  }

  private getMyAdjustments(): void {
    this.adjustmentService.getAdjustments(Number(this.engagementId))
      .subscribe((data: AdjustmentModel[]) => {
        this.adjustments = data;
      });
  }

  private fetchdatacheck_LeadQE() {

    if (this.engagementTemplateId != 3) {
      this.datacheckService.getDataCheckDataQE(this.engagementId).subscribe((response: any) => {
        const result = response;
        if (result.status === 'success') {
          this.colsQE = [];
          result.headers.map(item => {
            return {
              fieldname: item
            };
          }).forEach(item => {
            if (item.fieldname !== 'NetValue') {
              this.colsQE.push({
                field: this.getheaderField(item.fieldname),
                header: this.getheadernamebyFY(item.fieldname), visible: true, isEditable: false
              });
            }
          });

          this.accountDetailsQE = result.data;

          this.accountDetailsQE.forEach(item => {
            switch (item.standardizedMapping) {
              case "Net income":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.netIncome;
                break;
              case "Reported EBITDA":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.reportedEBITDA;
                break;
              case "Management adjustments:":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.managementAdjustments;
                break;
              case "Total management adjustments":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.totalManagementAdjustments;
                break;
              case "Management EBITDA":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.managementEBITDA;
                break;
              case "Sell-side due diligence adjustments:":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.sellSideDueDiligenceAdjustments;
                break;
              case "Total sell-side due diligence adjustments":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.totalSellSideDueDiligenceAdjustments;
                break;
              case "Sell-side EBITDA":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.sellSideEBITDA;
                break;
              case "Buy-side due diligence adjustments:":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.buySideDueDiligenceAdjustments;
                break;
              case "Total buy-side due diligence adjustments":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.totalBuySideDueDiligenceAdjustments;
                break;
              case "Buy-side EBITDA":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.buySideEBITDA;
                break;
              case "Adjusted EBITDA":
                item.standardizedMapping = this.currLangTranslation.adjustmentScreen.selectAdjustment.accountItems.adjustedEBITDA;
                break;
              default:
                break;
            }
          });

          this.frozenCols = [{ field: 'NetValue', header: 'NetValue' }
            , { field: 'StandardizedMapping', header: 'Accounts' }];
          this.loadspinner = false;
        } else {
          this.loadspinner = false;
        }
      }, err => {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        })
      }
      );
    }
    else {
      this.loadspinner = false;
    }
  }

  private getheadernamebyFY(headervalue: string) {
    if (this.isNumber(headervalue)) {
      if (this.engagementTemplateId == 1)
        return 'FY' + headervalue.substring(2, headervalue.length);
      else
        return 'FY' + headervalue.substring(2, headervalue.length) + "A";
    } else {
      if (headervalue === 'StandardizedMapping') {
        return this.currLangTranslation.adjustmentScreen.selectAdjustment.accounts;
      }
    }
    return headervalue;
  }

  private getheaderField(fieldName: string) {
    if (fieldName.toLowerCase().includes('ttm'))
      return "ttM" + fieldName.slice(3, 10);
    else
      return fieldName.charAt(0).toLowerCase() + fieldName.slice(1)
  }

  redirectToSchedules() {
    // When user logout session and directly accessing add adjustment button, we are setting the workflows values.
    if (this.flatfileUploaded === 1) {
      localStorage.setItem('generateDatabookViaTemplate' + this.engagementId + this.selectedregion, '1');
    } else {
      localStorage.setItem('generateDatabookViaTemplate' + this.engagementId + this.selectedregion, '0');
    }
    this.router.navigate(['/engagement/', this.engagementId, 'schedules']);
    this.messageService.clear();
  }

  closeEventpreview($event) {
    this.confirmdisplay = $event;
  }

  downloadToflatefile() {
    this.messageService.clear();
    this.loadspinnerflatfile = true;

    // Adds to the Queue.
    this.flatFileService.addFlatFileDownloadIntoQueue(this.engagementId).subscribe((queueId: any) => {
      this.auditingService.addAudit(this.engagementId, FunctionalityNames.FlatFileDownload).subscribe();
      this.flatFileDownloadWebJobQueueId = queueId.id;
      this.checkFlatFileDownloadProcessed();
    },
      err => {
        this.loadspinnerflatfile = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      });
  }

  downloadFlatFile() {
    this.loadspinnerflatfile = true;
    this.engagementservice.getEngagement(this.engagementId).subscribe((data) => {
      if (data !== null) {
        this.flatfileName = data.EngagementName;

        const today = new Date();
        let todayDateString;

        if (data.RegionId === 1) {
          todayDateString = ('0' + (today.getMonth() + 1)).slice(-2) + ('0' + today.getDate()).slice(-2) + today.getFullYear();
          this.flatfileName += '_FlatFile_' + `${todayDateString}.xlsx`;
        } else {
          todayDateString = ('0' + today.getDate()).slice(-2) + ('0' + (today.getMonth() + 1)).slice(-2) + today.getFullYear();
          this.flatfileName += '_FlatFile_' + `${todayDateString}.xlsx`;
        }

        this.flatFileService.getflatfile(this.flatFileDownloadWebJobQueueId)
          .subscribe(
            blobData => {
              this.loadspinnerflatfile = false;
              if (blobData) {
                saveAs(blobData, this.flatfileName);
              } else {
                this.loadspinnerflatfile = false;

                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                  summary: this.currLangTranslation.severitymessage.notification,
                  detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
                });
              }
            },
            err => {
              this.loadspinnerflatfile = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
              });
            }
          );
      } else {
        this.loadspinnerflatfile = false;

        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
    });
  }

  checkFlatFileDownloadProcessed() {
    this.webJobQueueService.getWebJobQueue(this.flatFileDownloadWebJobQueueId).subscribe((resp: WebJobQueueModel) => {
      if (resp) {
        if (!resp.isQueued) {

          this.isTimeIntervalInProgressFlatFileDownload = false;
          clearInterval(this.timeOutHandlerFlatFileDownload);

          if (resp.isError) {
            this.loadspinnerflatfile = false;

            if (resp.responseText === '') {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
              });
            } else {
              this.errorModel.confirmIsDisplay = true;
              this.errorModel.displayMessage = resp.responseText;
            }
          } else {
            this.downloadFlatFile();
          }
        } else {
          if (!this.isTimeIntervalInProgressFlatFileDownload) {
            this.timeOutHandlerFlatFileDownload = setInterval(() => {
              this.isTimeIntervalInProgressFlatFileDownload = true;
              this.loadspinnerflatfile = true;
              this.checkFlatFileDownloadProcessed();
            }, environment.webjobTimer);
          }
        }
      } else {
        this.loadspinnerflatfile = false;
        this.isTimeIntervalInProgressFlatFileDownload = false;
        clearInterval(this.timeOutHandlerFlatFileDownload);
      }
    }, err => {
      this.loadspinnerflatfile = false;
      this.isTimeIntervalInProgressFlatFileDownload = false;
      clearInterval(this.timeOutHandlerFlatFileDownload);
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
      });
    });
  }

  removeAdjusment() {
    if (this.adjustments.filter(w => w.isSelected === true).length === 0) {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.selectadjustmentComponentmessage.errorMessage.adjustmentSelectionError;
      return false;
    }
    const selectedAdjustments = this.adjustments.filter(x => x.isSelected);
    this.confirmationService.confirm({
      message: this.currLangTranslation.deleteAdjustmentmessage.errorMessage.removeAdjustment,
      header: this.currLangTranslation.labels.confirmation,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {

        this.loadspinner = true;
        this.adjustmentService.deleteSelectedAdjustment(this.engagementId, selectedAdjustments)
          .subscribe((data) => {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.selectadjustmentComponentmessage.deleteSuccessMessage.adjustmentSelection,
              sticky: true, closable: true
            });
            this.getMyAdjustments();
            this.fetchdatacheck_LeadQE();
          },
            error => {
              this.loadspinner = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true, closable: true
              });
            });
      },
      reject: () => { }
    });
  }

  downloadAdjusmentTemplate() {
    forkJoin([this.engagementservice.getEngagement(this.engagementId),
    this.adjustmentService.downloadAdjusmentTemplate(this.engagementId)])
      .subscribe((results) => {
        const enggModel: EngagementModel = results[0];
        const fileContent = results[1];
        const today = new Date();
        let todayDateString: any;
        let adjustmentTemplateFileName = enggModel.EngagementName;

        this.httpClient.get(`../assets/i18n/${enggModel.LanguageCode}.json`).subscribe((i18n: any) => {
          if (enggModel.TemplateId === 0 || enggModel.TemplateId === TemplateEnum.Americas) {
            todayDateString = ('0' + (today.getMonth() + 1)).slice(-2) + ('0' + today.getDate()).slice(-2) + today.getFullYear();
            adjustmentTemplateFileName += `_${i18n.labels.downloadAdjustmentFileSuffixName}_` + `${todayDateString}.xlsx`;
          } else {
            todayDateString = ('0' + today.getDate()).slice(-2) + ('0' + (today.getMonth() + 1)).slice(-2) + today.getFullYear();
            adjustmentTemplateFileName += `_${i18n.labels.downloadAdjustmentFileSuffixName}_` + `${todayDateString}.xlsx`;
          }
          this.masterHelpService.downloadFileByBlob(fileContent, adjustmentTemplateFileName, this.EXCEL_CONTENT_TYPE);
        });
      },
        error => {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true, closable: true
          });
        });
  }

  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (output.type === 'allAddedToQueue') { // when all sourceFiles added in queue
      // uncomment this if you want to auto upload sourceFiles when added
      if (this.sourceFiles.length > 0) {
        const event: UploadInput = {
          type: 'uploadAll',
          url: this.adjustmentUploadURL + `${this.engagementId}`,
          method: 'POST'
          , headers: { 'Authorization': 'Bearer ' + (environment.isBearerAuthorizationEnabled ? localStorage['dbamsaltoken'] : environment.sampleToken) }
        };
        this.uploadInput.emit(event);
      }
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
      if (output.file.size > this.maxFlatFileSizeUploadLimit) {
        this.loadspinner = false;
        fileInput.value = '';
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage = this.currLangTranslation.severitymessage.MaxsizeError + ' ' + output.file.name + ' ' + this.currLangTranslation.severitymessage.ofSizeMoreThan + ' ' +
          environment.maxFlatFileSizeUploadLimit + ' MB';
      } else {
        this.sourceFiles.push(output.file);
      }
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      this.loadspinner = true;
      // update current data in sourceFiles array for uploading file
      const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.sourceFiles[index] = output.file;
    } else if (output.type === 'done' && typeof output.file !== 'undefined') {
      // update current data in sourceFiles array for uploading file
      if (output.file && output.file.response && output.file.response.message === 'Invalid File Format') {
        fileInput.value = '';
        this.uploadInput.emit({ type: 'remove', id: output.file.id });
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
        return;
      }

      if (this.sourceFiles[0].responseStatus === 400) {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.FormateError,
          sticky: true, closable: true
        });
      } else {
        if (this.sourceFiles[0].response.status === severitymessage.success) {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.downloadUploadAdjustmentComponentmessage.successMessage.rowsUploaded,
            sticky: true, closable: true
          });
          this.getMyAdjustments();
          this.fetchdatacheck_LeadQE();
        } else if (this.sourceFiles[0].response.message && this.sourceFiles[0].response.message !== '') {
          const msg: string = this.sourceFiles[0].response.message;
          const splitMessage = msg.split("|");
          let errMessage: string = ''
          if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError1) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError1;
          }
          else if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError2) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError2;
          }
          else if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError3) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError3;
            errMessage = errMessage.replace("{0}", splitMessage[1]).toString();
          }
          else if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError4) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError4;
            errMessage = errMessage.replace("{0}", splitMessage[1]).toString();
          }
          else if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError5) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError5;
            errMessage = errMessage.replace("{0}", splitMessage[1]).toString();
          }
          else if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError6) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError6;
            errMessage = errMessage.replace("{0}", splitMessage[1]).toString();
          }
          else if (splitMessage[0] === AdjustmentMessageConstants.adjustmentError7) {
            errMessage = this.currLangTranslation.commonMessages.adjustmentError7;
            errMessage = errMessage.replace("{0}", splitMessage[1]).toString();
          }
          else {
            errMessage = this.sourceFiles[0].response.message;
          }
          this.loadspinner = false;
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage = errMessage;
        } else {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.downloadUploadAdjustmentComponentmessage.errorMessage.uploadSummary,
            sticky: true, closable: true
          });
        }
      }
      this.sourceFiles = [];
      // Clear file - to upload same file name twice
      fileInput.value = '';
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      // Replace with Notification service
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
      fileInput.value = '';
      this.loadspinner = false;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
      this.loadspinner = false;
    } else if (output.type === 'dragOver') {
      // this.dragOver = true;
    } else if (output.type === 'dragOut') {
      // this.dragOver = false;
    } else if (output.type === 'drop') {
      // this.dragOver = false;
    }
  }
}
